import { PerAdultLabel } from '@/src/components/common/srp/perAdultLabel'
import { Plan } from '@/src/components/desktop/srp/fareFamily/types'
import useSearchResults from '@/src/hooks/srp/useSearchResults'
import { Box, Button, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import React from 'react'

type FareFamilyFooterProps = {
    handleFareFamilyBookClick: (e: React.MouseEvent<HTMLButtonElement>) => void
    isCreateItineraryLoading?: boolean
    selectedPlan: Plan
}

const FareFamilyFooter = ({
    selectedPlan,
    handleFareFamilyBookClick,
    isCreateItineraryLoading
}: FareFamilyFooterProps) => {
    const t = useTranslations()
    const { selectedJourneyLeg } = useSearchResults()
    return (
        <Box width="100%">
            {/* Coupon Banner */}
            {/* {selectedPlan.benefitsText.exclusiveBenefits && (
                <Box
                    sx={{
                        width: '100%',
                        backgroundColor: '#00c03f',
                        color: 'white',
                        fontWeight: 600,
                        fontSize: '14px',
                        px: 1.5,
                        py: 1.25,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}
                >
                    <LocalOfferIcon sx={{ color: 'white', fontSize: 20 }} />
                    <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
                        {selectedPlan.benefitsText.exclusiveBenefits}
                    </Typography>
                </Box>
            )} */}

            {/* Price + Book Button */}
            <Box
                sx={{
                    width: '100%',
                    px: '8px',
                    backgroundColor: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
            >
                <Box>
                    <Typography sx={{ fontSize: '20px', fontWeight: 700 }}>
                        {!!selectedPlan.planPricePrefix && selectedPlan.planPricePrefix} {selectedPlan.displayPrice}{' '}
                        {selectedPlan.isPerPaxPricingDefined && <PerAdultLabel />}
                    </Typography>
                    {selectedJourneyLeg == 0 && (
                        <Typography sx={{ fontSize: '12px', color: 'rgba(17, 163, 68, 1)' }}>
                            {selectedPlan.benefitsText.exclusiveBenefits}
                        </Typography>
                    )}
                </Box>

                <Button
                    onClick={handleFareFamilyBookClick}
                    variant="customVariantPrimary"
                    disabled={isCreateItineraryLoading}
                    sx={theme => ({
                        // backgroundColor: theme.palette.primary.main,
                        borderRadius: '0.5rem',
                        px: 5,
                        py: 1.2,
                        boxShadow: 'none',
                        // '&:hover': {
                        //     backgroundColor: theme.palette.secondary.main,
                        //     color: theme.palette.primary.main,
                        //     boxShadow: 'none'
                        // }
                    })}
                >
                    {isCreateItineraryLoading ? t('common.Loading') : t('common.Continue')}
                </Button>
            </Box>
        </Box>
    )
}

export default FareFamilyFooter
